//@import dependencies
import React from 'react'
import { useTranslation } from 'react-i18next'
//@end

//@import components
import AppContainer from 'app_components/layouts/app'
import BreadcrumbComponent from 'app_components/commons/breadcrumb'
import TeacherLandingModule from 'app_components/modules/admin/landings/teacherLanding'
//@end

// @import hooks
// @end

// @INFO Import types
// @end

// @INFO Import services
// @end

// @INFO Import Styles
import './../teacherLandingScreen.scss'

// @ADD Component types
interface ITeacherLandingScreenLayoutProps {}

const TeacherLandingScreenLayout: React.FC<ITeacherLandingScreenLayoutProps> = (props) => {

  const { t } = useTranslation()

  return(
    <AppContainer>
      <div className='teacher_landing-screen'>
        <BreadcrumbComponent links={['/admin/landings', '#']} texts={[`${t('components.breadcrumb.landings')}`, `${t('components.breadcrumb.teacher_landing')}`]} />

        <div className="row">
          <div className="col-6">
            <TeacherLandingModule />

          </div>
        </div>
      </div>
    </AppContainer>
  )
}

export default TeacherLandingScreenLayout
